import { useMediaQuery } from 'react-responsive';
import PcReviewDetail from '@/components/pc/Review/ReviewDetail';
import MoReviewDetail from '@/components/mo/Review/ReviewDetail';

export default function ReviewDetailPage() {
  const isMobile = useMediaQuery({ maxWidth: 600 });

  return isMobile ? <MoReviewDetail /> : <PcReviewDetail />;
}
